export interface ReleaseCardEditionIdentity {
  country: string | null;
  fallback: string | null;
  format: string | null;
  text: string;
  year: string | null;
}

interface ReleaseCardEditionIdentityInput {
  catnos: string[];
  country: string | null;
  date: string | null;
  format: string | null;
  labelNames: string[];
  title: string;
}

function nonEmpty(value: string | null | undefined): string | null {
  const trimmed = value?.trim();
  return trimmed ? trimmed : null;
}

function releaseYear(date: string | null): string | null {
  return date?.match(/^(\d{4})/)?.[1] ?? null;
}

export function releaseCardEditionIdentity(
  input: ReleaseCardEditionIdentityInput,
): ReleaseCardEditionIdentity {
  const year = releaseYear(input.date);
  const country = nonEmpty(input.country);
  const format = nonEmpty(input.format);
  const primaryParts = [year, country, format].filter((part): part is string => part !== null);
  const fallbackParts = [input.labelNames[0], input.catnos[0]]
    .map(nonEmpty)
    .filter((part): part is string => part !== null);
  const fallback = primaryParts.length === 0 ? fallbackParts.join(" · ") || input.title : null;
  const text = primaryParts.join(" · ") || fallback || input.title;

  return {
    country,
    fallback,
    format,
    text,
    year,
  };
}
